import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Alert, Button, Field, Input } from '@itds/elements/index.js';
import { PASSWORD_RULES } from '@itds/Constants';
import { Colors } from '@itds/Theme';

import Api from '@brokerage/utils/Api';

const ChangePassword = () => {
  const styles = {
    password_rule: {
      marginBottom: 10
    },
    password_rule_valid: {
      color: '#999'
    },
    icon: {
      fontSize: 20,
      verticalAlign: 'middle',
      color: '#ccc',
      marginRight: 2
    },
    icon_green: {
      fontSize: 20,
      verticalAlign: 'middle',
      color: Colors.GREEN.hex,
      marginRight: 2
    }
  };
  const params = useParams();
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState(['placeholder']);
  const [alert, setAlert] = useState(null);

  const handlePasswordChange = e => {
    setPassword(e.target.value);

    const errors = [];
    const password = e.target.value;

    PASSWORD_RULES.forEach(rule => {
      if (!rule.pattern.test(password)) {
        errors.push(rule.name);
      }
    });

    setErrors(errors);
  };

  const handleSave = () => {
    Api.updateMember(params.id, { password, password_confirmation: password })
      .then(() => {
        setAlert({ type: 'success', children: 'Password updated successfully.' });
      })
      .catch(() => {
        setAlert({ type: 'error', children: 'Password was not updated.' });
      });

    setPassword('');
    setErrors([]);
    setTimeout(() => {
      setAlert(null);
    }, 2000);
  };

  return (
    <div>
      {alert ? <Alert {...alert} /> : null}

      <Field label='Password' style={{ width: 300 }}>
        <Input onChange={handlePasswordChange} type='password' value={password} />
      </Field>

      {PASSWORD_RULES.map(rule => {
        const is_valid = !errors.includes('placeholder') && !errors.includes(rule.name);

        return (
          <div
            key={rule.name}
            style={Object.assign({}, styles.password_rule, is_valid && styles.password_rule_valid)}
          >
            {is_valid ? (
              <i className='mdi mdi-checkbox-marked-circle-outline' style={styles.icon_green} />
            ) : (
              <i className='mdi mdi-checkbox-blank-circle-outline' style={styles.icon} />
            )}{' '}
            {rule.label}
          </div>
        );
      })}

      <Button disabled={errors.length} inline={true} onClick={handleSave} style={{ marginTop: 20 }}>
        Update Password
      </Button>
    </div>
  );
};

export default ChangePassword;
